module.exports = __webpack_public_path__ + "img/potter.dc958962.svg";